// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_clip".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { clipAgentSourceValues, clipFramingValues, footageActionValues, stockClipSourceValues, stockClipTagStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "stock_clip" table (1:1 with a DB row, on the wire). */
export const stockClipAtomSchema = z.object({
    id: z.string(),
    vertical: z.string().nullable(),
    agentSlug: z.string().nullable(),
    techniqueSlug: z.string().nullable(),
    regions: z.array(z.string()),
    treatmentScopes: z.unknown(),
    footageActions: z.array(z.enum(footageActionValues)),
    tagStatus: z.enum(stockClipTagStatusValues),
    procedureNeutral: z.boolean(),
    sourceTitle: z.string().nullable(),
    tagReview: z.unknown().nullable(),
    reviewedById: z.string().nullable(),
    reviewedAt: z.string().datetime().nullable(),
    agentSource: z.enum(clipAgentSourceValues),
    source: z.enum(stockClipSourceValues),
    externalAssetId: z.string().nullable(),
    acquiredAt: z.string().datetime().nullable(),
    hasIdentifiableFace: z.boolean().nullable(),
    trimInMs: z.number().nullable(),
    trimOutMs: z.number().nullable(),
    framing: z.enum(clipFramingValues).nullable(),
    visualDescription: z.string().nullable(),
    contentType: z.string(),
    isGeneric: z.boolean(),
    description: z.string(),
    mediaType: z.string(),
    blobUrl: z.string(),
    transcodedBlobUrl: z.string().nullable(),
    durationSec: z.number().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    active: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stockClip.js.map